import { Theme } from "@mui/material";

export const loadingContainer = ({ breakpoints }: Theme) => ({
  width: "100%",
  height: "150%",
  bgcolor: "black",
  position: "absolute",
  opacity: 0.7,
  left: 0,
  top: "90px",
});

export const loadingSubContainer = ({ breakpoints }: Theme) => ({
  bgcolor: "white",
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  opacity: 1,
  p: 3,
  borderRadius: 2,
});
